import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { CollectingRequestsViewModel } from "../collectingRequests/collectingRequests-viewModel";
import { SendCartableFormViewModel } from "../sendCartableForm/sendCartableForm-viewModel";
import { SendFormViewModel } from "../sendForm/sendForm-viewModel";
import { SendPackageProductsViewModel } from "../sendPackageProducts/sendPackageProducts-viewModel";
import { SendPackageRequestsViewModel } from "../sendPackageRequests/sendPackageRequests-viewModel";
import  { SendPackageDetailView } from "./sendPackageDetail-view"
import { SendToLocalNotificationMessage } from "src/server/localNotification";

export class SendPackageDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: SendCartableFormViewModel, sendPackageId) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.sendPackageTabs = ObservableArray.create<ISendPackageTab>();
        this.sendPackageId = sendPackageId;
    }
    closePopup(message?:string) {
    }
    
    GetDefaultView(): View <ViewModel> {
        return new SendPackageDetailView();
    }
    public getTypeId(): string {
        return "VM-3029A4FD-6620-4626-A3D8-57CC07EA82E3"
    }
    private _typedParent : SendCartableFormViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set receiveTime(v: moment.Moment) { this._receiveTime = v; } public get receiveTime(): moment.Moment { return this._receiveTime;} private _receiveTime: moment.Moment;
    public set sentTime(v: moment.Moment) { this._sentTime = v; } public get sentTime(): moment.Moment { return this._sentTime;} private _sentTime: moment.Moment;
    public set orderNumber(v: string) { this._orderNumber = v; } public get orderNumber(): string { return this._orderNumber;} private _orderNumber: string;
    public set packageNumber(v: number) { this._packageNumber = v; } public get packageNumber(): number { return this._packageNumber;} private _packageNumber: number;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState;} private _sendPackageState: number;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName;} private _driverName: string;
    public set driverPhone(v: string) { this._driverPhone = v; } public get driverPhone(): string { return this._driverPhone;} private _driverPhone: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend;} private _canSend: boolean;
    public set sendPackageTabs(v: ObservableArray<ISendPackageTab>) { this._sendPackageTabs = v; } public get sendPackageTabs(): ObservableArray<ISendPackageTab> { return this._sendPackageTabs;} private _sendPackageTabs: ObservableArray<ISendPackageTab>;
    public set selectedSendPackageTab(v: ISendPackageTab) { 
        this._selectedSendPackageTab = v; 
        this.selectedSendPackageTab?.load(this.sendPackageId);
    } public get selectedSendPackageTab(): ISendPackageTab { return this._selectedSendPackageTab;} private _selectedSendPackageTab: ISendPackageTab;
    public set sendPackageId(v: string) { 
        this._sendPackageId = v;
        this.load();
    } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetSendPackageDetail',{
                SendPackageId:this.sendPackageId
            });
            this.creationTime = moment.utc(result.CreatedTime);
            this.receiveTime = result.ReceiveTime==null ? null : moment.utc(result.ReceiveTime);
            this.sentTime = result.SentTime==null ? null : moment.utc(result.SentTime);
            this.orderNumber = result.OrderNumber;
            this.sendPackageState = result.State;
            this.canSend = this.sendPackageState === 0;
            this.toWarehouseId = result.ToWarehouseId;
            this.toWarehouseName = result.ToWarehouseName;
            this.fromWarehouseId = result.FromWarehouseId;
            this.fromWarehouseName = result.FromWarehouseName;
            this.carNumber = result.CarNumber;
            this.driverPhone = result.DriverPhone;
            this.driverName = result.DriverName ? result.DriverName + '(' + this.driverPhone + ')' : '';
            this.createTabs();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    createTabs() {
        this.sendPackageTabs.update(...[
            new SendPackageRequestsViewModel(this),
            new SendPackageProductsViewModel(this),
            new CollectingRequestsViewModel(this),
        ]);
        this.selectedSendPackageTab = this.sendPackageTabs[0];
    }

    close(){
        this.closePopup('yes');
    }
    
    async send(){
        let deliveryForm = new SendFormViewModel(this._typedParent);
        await deliveryForm.loadById(this.sendPackageId);
        if (deliveryForm.sendFormItems.length > 0) {
            let result = await this.requestShowingPopup(deliveryForm);
        }
    }
    
    async print(){
        new PrintExitFormAction().Print(this,this.sendPackageId);
    }

}

export class PrintExitFormAction{
  
    public set showProductIndexOnPrint(v: boolean) { this._showProductIndexOnPrint = v; } public get showProductIndexOnPrint(): boolean { return this._showProductIndexOnPrint;} private _showProductIndexOnPrint: boolean;
  
    public async Print(parent:ViewModel, sendPackageId:string):Promise<void>{
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetSendPackageDetailWithItems',{
            SendPackageId:sendPackageId
        });
        return this.PrintFromDto(parent,result);
    }

    public async PrintFromDto(parent:ViewModel, result:any){
        try {
            let result = await ServerConnection.callServer('/Complex/SettingServices/GetShowProductIndexOnPrintSetting',{});
                this.showProductIndexOnPrint = result.ShowProductIndexOnPrint;
        } catch (ex) {
            console.log(ex);
        }
        var message = new SendToLocalNotificationMessage("requestPrint",{
            Form:"ExitSheetReport",
            Data:{
                CopyCount:1,
                ShowProductIndexOnPrint : this.showProductIndexOnPrint,
                CompanyName:'',
                ExitSheetNumber:result.ExitFormNumber,
                RemittanceNumber:result.TripNo,
                DriverName:result.DriverName,
                TruckNumber:result.CarNumber,
                ExitDate:moment.utc(result.SentTime),
                Origin:result.FromWarehouseName,
                Destination:result.ToWarehouseName,
                Items:result.SendPackageItems.map((x,i)=>{
                    return {
                        RowIndex:i+1,
                        ProductCode:x.ProductCode,
                        ProductName:x.ProductName,
                        ProductIndex:x.ProductIndex,
                        WarehousePlacement:x.WarehouseLocation,
                        Amount:x.OrderAmount,
                    };
                })
            }
        });
        return parent.handleMessage(message);
    }
}

export interface ISendPackageTab{
    load(sendPackageId);
    get tabName(): string;
}
